import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import Spinner from "../components/common/Spinner";
import AuthCard from "./AuthCard";
import { acceptInvite, getInvite } from "../api/studioAPI";
import { colors, typography, buttons, form } from "../styles/index";

const MIN_PASSWORD = 8;

// /accept-invite?token=... - an invited colleague sets a password and joins the org (the link from Settings → Members).
export default function AcceptInvitePage({ onLogin }) {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [invite, setInvite] = useState(null);
  const [error, setError] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!token) { setError("This invitation link is incomplete."); return; }
    getInvite(token).then(setInvite).catch((e) => setError(e.message));
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < MIN_PASSWORD) return setError(`Use at least ${MIN_PASSWORD} characters for the password.`);
    if (password !== confirm) return setError("Passwords do not match.");
    setLoading(true);
    try {
      const session = await acceptInvite(token, password);
      onLogin(session.token, session.avatar, session.refresh_token);
      navigate("/app");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
    return undefined;
  };

  if (!invite) {
    return (
      <AuthCard subtitle="Join your team">
        {error
          ? <p role="alert" style={form.error}>{error} <Link to="/login">Sign in</Link> instead?</p>
          : <p style={{ textAlign: "center" }}><Spinner size={16} /> Checking the invitation...</p>}
      </AuthCard>
    );
  }

  return (
    <AuthCard subtitle={`Join ${invite.org_name || "your team"}`}>
      <p style={{ ...typography.small, color: colors.textMuted }}>
        {invite.invited_by} invited <strong>{invite.username}</strong> as a{invite.role === "owner" ? "n owner" : " creator"}.
        Choose a password to finish.
      </p>
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: 16 }}>
          <label style={form.label} htmlFor="password">Password</label>
          <input id="password" type="password" autoComplete="new-password" style={form.input} disabled={loading}
            value={password} onChange={(e) => setPassword(e.target.value)} />
        </div>
        <div style={{ marginBottom: 16 }}>
          <label style={form.label} htmlFor="confirm">Confirm password</label>
          <input id="confirm" type="password" autoComplete="new-password" style={form.input} disabled={loading}
            value={confirm} onChange={(e) => setConfirm(e.target.value)} />
        </div>
        {error && <div style={{ ...form.error, marginBottom: 12 }} role="alert">{error}</div>}
        <button type="submit" disabled={loading} style={{ ...buttons.primary, width: "100%", opacity: loading ? 0.7 : 1 }}>
          {loading ? <><Spinner size={14} /> Joining...</> : "Join the team"}
        </button>
      </form>
    </AuthCard>
  );
}
